var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"chart-wrapper",attrs:{"element-loading-background":"transparent"}},[(_vm.data.length)?_c('sankey-chart',{attrs:{"data":_vm.computedData,"size":{ width: 1110, height: 768 },"monitor-url-params":{
      flow: _vm.filter.flow,
      startAt: _vm.filter.startAt.toISOString(),
      endAt: _vm.filter.endAt.toISOString()
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }